import { createDivIn, createHeaderIn, createParagraphIn, setElementInnerHTML, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { UIStoreGiftBaseSelectionController } from './UIStoreGiftBaseSelectionController.ts';
import { ColonistGiftMembershipProduct } from '../../../../../shared/store/ColonistGiftMembershipProduct.ts';
import { UIStoreGiftMembershipProductView } from './UIStoreGiftMembershipProductView.ts';
import { ColonistMembershipType, ColonistOneTimePurchaseType } from '@colonist/types';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../analytics/Analytics.ts';
import { getNestedTranslation } from '@colonist/i18n';
import { UIUtilsNotifications } from '../../notifications/UIUtilsNotifications.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { DiscordAnnualMembershipPrices } from '../../../../../shared/store/StoreConstants.ts';
import { ColonistMembershipProduct } from '../../../../../shared/store/ColonistMembershipProduct.ts';
export class UIStoreGiftTierSelectionController extends UIStoreGiftBaseSelectionController {
    get selectedTier() {
        return this.selectedGiftTier;
    }
    get giftDuration() {
        return this.selectedGiftDuration;
    }
    selectGiftTier(giftTier, membershipType) {
        for (const productView of this.membershipProductViews){
            productView.deselect();
            const oneTimePurchaseType = productView.membershipProduct.oneTimePurchaseType;
            if (oneTimePurchaseType == undefined) continue;
            if (oneTimePurchaseType == giftTier) productView.select();
        }
        const isSelectedTierAnnual = UIStoreGiftTierSelectionController.isSelectedTierAnnual(giftTier);
        this.selectedGiftDuration = isSelectedTierAnnual ? 12 : 1;
        this.selectedGiftTier = giftTier;
        this.enableNextButton();
        this.markAsCompleted(true);
        this.setTabAnnual(isSelectedTierAnnual);
        this.updateSelectedTierInfoText(membershipType);
        const giftTierSelectionAnalyticData = {
            type: AnalyticEventType.SelectedGiftTier,
            category: AnalyticEventCategory.GiftMembershipOverlay,
            floatValue: giftTier
        };
        void CA.sendAnalyticEvent(giftTierSelectionAnalyticData);
    }
    deselectAllGiftTiers() {
        for (const productView of this.membershipProductViews){
            productView.deselect();
        }
        this.selectedGiftTier = undefined;
        this.setTabAnnual(true);
        this.disableNextButton();
        this.markAsCompleted(false);
        this.topNavigationButtonSelectedTierInfo.classList.add('hidden');
    }
    createSidebarButton() {
        super.createSidebarButton();
        const textsContainer = createDivIn(this.selectionTitle, 'store-gift-sidebar-texts');
        createParagraphIn(textsContainer, {
            key: 'strings:storePage.sections.giftOverlay.tierSelection.buttonTitle'
        }, '');
        this.topNavigationButtonSelectedTierInfo = createDivIn(textsContainer, 'store-gift-sidebar-texts subtext hidden');
    }
    createPageContent() {
        super.createPageContent();
        createHeaderIn(this.pageTitle, {
            key: 'strings:storePage.sections.giftOverlay.tierSelection.tabTitle'
        }, '', '', 'H2');
        const toggleContainer = createDivIn(this.pageContainer, 'toggle-container');
        this.toggleButtonMonthly = createDivIn(toggleContainer, 'toggle-tab');
        createParagraphIn(this.toggleButtonMonthly, {
            key: 'strings:storePage.membership.frequency.oneMonth'
        }, '');
        setElementOnClick(this.toggleButtonMonthly, ()=>this.setTabAnnual(false));
        this.toggleButtonAnnual = createDivIn(toggleContainer, 'toggle-tab');
        const discount = UIStoreGiftTierSelectionController.getAnnualDiscount();
        createParagraphIn(this.toggleButtonAnnual, {
            key: 'strings:storePage.membership.frequency.oneYear',
            options: {
                context: 'store',
                discount: discount
            }
        }, '');
        setElementOnClick(this.toggleButtonAnnual, ()=>this.setTabAnnual(true));
    }
    createGiftMembershipProducts() {
        const tiersContainer = createDivIn(this.pageContainer, 'store-gift-overlay-tiers-container');
        const membershipProducts = ColonistGiftMembershipProduct.getAllMembershipProducts();
        for (const product of membershipProducts){
            const membership = new UIStoreGiftMembershipProductView(tiersContainer, this.storeState, product, this.localizedStoreProductData);
            UIStoreGiftTierSelectionController.setDiscordGiftPrice(membership);
            const oneTimePurchaseType = product.oneTimePurchaseType;
            if (oneTimePurchaseType == undefined) continue;
            setElementOnClick(membership.productDiv, ()=>this.selectGiftTier(oneTimePurchaseType, product.type));
            this.membershipProductViews.push(membership);
        }
    }
    setTabAnnual(showAnnualProducts) {
        this.setToggleButtonsActiveState(showAnnualProducts);
        for (const productView of this.membershipProductViews){
            const isAnnualProduct = productView.isAnnualGiftMembership();
            const shouldHideProduct = isAnnualProduct != showAnnualProducts;
            productView.productDiv.classList.toggle('hidden', shouldHideProduct);
        }
    }
    setToggleButtonsActiveState(showAnnualProducts) {
        if (showAnnualProducts) {
            this.toggleButtonAnnual.classList.add('active');
            this.toggleButtonMonthly.classList.remove('active');
        } else {
            this.toggleButtonMonthly.classList.add('active');
            this.toggleButtonAnnual.classList.remove('active');
        }
    }
    static getAnnualDiscount() {
        const defaultDiscount = 20;
        if (!UIUtilsEjsVariables.isUserOnDiscord) return defaultDiscount;
        const nonDiscountedAnnualPrice = ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly).price * 12;
        return Math.round((1 - DiscordAnnualMembershipPrices.PREMIUM / nonDiscountedAnnualPrice) * 100);
    }
    static isSelectedTierAnnual(giftTier) {
        switch(giftTier){
            case ColonistOneTimePurchaseType.GiftEliteYearly:
            case ColonistOneTimePurchaseType.GiftPremiumYearly:
            case ColonistOneTimePurchaseType.GiftPlusYearly:
            case undefined:
                return true;
            case ColonistOneTimePurchaseType.GiftEliteMonthly:
            case ColonistOneTimePurchaseType.GiftPremiumMonthly:
            case ColonistOneTimePurchaseType.GiftPlusMonthly:
                return false;
            default:
                throw new Error('Invalid gift tier');
        }
    }
    updateSelectedTierInfoText(membershipType) {
        setElementInnerHTML(this.topNavigationButtonSelectedTierInfo, this.getSelectedTierInfoText(membershipType));
        this.topNavigationButtonSelectedTierInfo.classList.remove('hidden');
    }
    getSelectedTierInfoText(membershipType) {
        const giftTier = this.selectedGiftTier;
        const frequencyMonth = {
            key: 'strings:storePage.membership.frequency.oneMonth'
        };
        const frequencyYear = {
            key: 'strings:storePage.membership.frequency.oneYear'
        };
        const frequencyKey = UIStoreGiftTierSelectionController.isSelectedTierAnnual(giftTier) ? frequencyYear : frequencyMonth;
        const tierKey = UIUtilsNotifications.getMembershipTitleFromType(membershipType);
        return getNestedTranslation({
            key: 'strings:storePage.sections.giftOverlay.tierSelection.selectedTier'
        }, {
            frequency: frequencyKey,
            tier: tierKey
        });
    }
    static setDiscordGiftPrice(giftMembershipView) {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        const discordMembershipPrice = this.getDiscordGiftPrice(giftMembershipView.membershipProduct);
        if (discordMembershipPrice == undefined) return;
        const discordPrice = `${(discordMembershipPrice / 100).toFixed(2)}`;
        giftMembershipView.setPrice(discordPrice);
    }
    static getDiscordGiftPrice(membership) {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return membership.price;
        if (membership.oneTimePurchaseType == undefined) return undefined;
        switch(membership.oneTimePurchaseType){
            case ColonistOneTimePurchaseType.GiftPlusYearly:
                return DiscordAnnualMembershipPrices.PLUS;
            case ColonistOneTimePurchaseType.GiftPremiumYearly:
                return DiscordAnnualMembershipPrices.PREMIUM;
            case ColonistOneTimePurchaseType.GiftEliteYearly:
                return DiscordAnnualMembershipPrices.ELITE;
            default:
                return membership.price;
        }
    }
    constructor(parentDiv, sidebarContainer, storeState, hideGiftOverlayAction, checkoutAction, shouldTierSelectionBeSecondPage, localizedStoreProductData){
        super(parentDiv, sidebarContainer, hideGiftOverlayAction, checkoutAction), this.membershipProductViews = [], this.selectedGiftDuration = 1, this.localizedStoreProductData = [];
        this.storeState = storeState;
        this.localizedStoreProductData = localizedStoreProductData;
        this.createGiftMembershipProducts();
        this.mainCTAButton = this.createNextButton();
        this.disableNextButton();
        this.mainCTAButton.classList.add('gift-tier-selection-next-button');
        this.setTabAnnual(true);
    }
}
